import { render, staticRenderFns } from "./DialogFormInventory.vue?vue&type=template&id=5d6fd612&"
import script from "./DialogFormInventory.vue?vue&type=script&lang=js&"
export * from "./DialogFormInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports